import { Typography, Button, Tag } from '@navi/web-ui/lib/primitives';
import { InfoIcon } from '@navi/web-ui/lib/icons';
import ClockFilledIcon from '@navi/web-ui/lib/icons/ClockIcon';
import CheckIcon from '@cp/src/assets/icons/CheckIcon';
import { AllocationStatusDisplayProps, CompletionStatus, STATUS_MESSAGES } from './consts';

const AllocationStatusDisplay = (props: AllocationStatusDisplayProps) => {
  const { completionStatus, onReupload } = props;

  const isNeedsReupload = completionStatus === CompletionStatus.NEEDS_REUPLOAD;
  const isInProgress =
    completionStatus === CompletionStatus.IN_PROGRESS_NON_FINAL ||
    completionStatus === CompletionStatus.IN_PROGRESS_FINAL;
  const isCompleted = completionStatus === CompletionStatus.COMPLETED;

  return (
    <>
      <div className="flex items-center gap-2">
        {isNeedsReupload && (
          <>
            <InfoIcon />
            <Typography variant="h5" color="var(--navi-color-gray-c3)">
              {STATUS_MESSAGES.NEEDS_REUPLOAD}
            </Typography>
          </>
        )}
        {isInProgress && (
          <>
            <InfoIcon />
            <Typography variant="h5" color="var(--navi-color-gray-c3)">
              {STATUS_MESSAGES.IN_PROGRESS}
            </Typography>
          </>
        )}
      </div>

      {isNeedsReupload && (
        <Button variant="primary" onClick={onReupload} className="whitespace-nowrap">
          Re upload to ameyo
        </Button>
      )}
      {isInProgress && (
        <Tag
          label="Uploading in progress"
          color="orange"
          variant="transparent"
          startAdornment={<ClockFilledIcon color="var(--navi-color-orange-base)" />}
        />
      )}
      {isCompleted && (
        <Tag label="SUCCESS" color="green" variant="transparent" startAdornment={<CheckIcon />} />
      )}
    </>
  );
};

export default AllocationStatusDisplay;
